import { FormEvent, useState } from 'react';
import type { AreaRecord } from '../../types/registry';
import { newAreaId } from './facilityHelpers';

interface AreaCreateDialogProps {
  saving: boolean;
  error: string | null;
  onCreate: (area: AreaRecord) => void;
  onCancel: () => void;
}

export function AreaCreateDialog({
  saving,
  error,
  onCreate,
  onCancel,
}: AreaCreateDialogProps): JSX.Element {
  const [name, setName] = useState('');
  const [floor, setFloor] = useState(0);
  const [description, setDescription] = useState('');

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!name.trim()) return;
    onCreate({
      area_id: newAreaId(),
      name: name.trim(),
      floor,
      description: description.trim(),
    });
  }

  return (
    <div className="modal-backdrop" onClick={saving ? undefined : onCancel}>
      <div className="modal-card" onClick={(event) => event.stopPropagation()}>
        <h2>Add area</h2>
        <p className="modal-card__copy">Create one area for this facility.</p>

        <form className="invite-form" onSubmit={handleSubmit}>
          <label className="form-field">
            <span>Area name</span>
            <input value={name} onChange={(event) => setName(event.target.value)} required autoFocus />
          </label>
          <label className="form-field">
            <span>Floor</span>
            <input
              type="number"
              value={floor}
              onChange={(event) => setFloor(Number(event.target.value) || 0)}
            />
          </label>
          <label className="form-field">
            <span>Description</span>
            <input
              value={description}
              onChange={(event) => setDescription(event.target.value)}
            />
          </label>

          {error ? <div className="form-error">{error}</div> : null}

          <div className="modal-card__actions">
            <button className="primary-button" disabled={saving} type="submit">
              {saving ? 'Creating...' : 'Create area'}
            </button>
            <button className="ghost-button" type="button" disabled={saving} onClick={onCancel}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
